module.exports = __webpack_public_path__ + "img/shoucang.78c31961.png";